// Template275: Pekín - Metro p.2 (MetroPekinPagina2.jsx)
// Cabecera, lista estaciones, sección Consejos (ul), caja Mapas y apps, caja amarilla Dónde dormir.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template275 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const sectionTitle = page?.texts?.[1]?.content;
	const consejosHtml = page?.texts?.[2]?.content;
	const consejosTitle = page?.texts?.[3]?.content;
	const mapasTitle = page?.texts?.[4]?.content;
	const mapasBody = page?.texts?.[5]?.content;
	const dondeDormir = page?.texts?.[6]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const logoImage = getCanvasImageUrl("logo");
	const estaciones = Array.isArray(page?.data?.estaciones)
		? page.data.estaciones
		: [];
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 66,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: 2.5,
					flex: 1,
					overflow: "auto",
				}}
			>
				{/* Estaciones por lugares */}
				{sectionTitle && (
					<Box component="h3" sx={{ ...estiloH3, marginBottom: 1 }}>
						{sectionTitle}
					</Box>
				)}
				{estaciones.length > 0 && (
					<Box
						data-block-id="text-2"
						sx={{
							display: "flex",
							flexDirection: "column",
							gap: 1,
							marginBottom: 1.75,
						}}
					>
						{estaciones.map((item) => (
							<Box
								key={item.lugar}
								sx={{
									backgroundColor: "#fff",
									borderRadius: "10px",
									padding: "10px 12px",
									border: "2px solid #e8e8e8",
								}}
							>
								<Box
									sx={{
										fontWeight: 700,
										fontSize: 12,
										color: actualHeaderColor,
										marginBottom: 0.5,
									}}
								>
									{item.lugar}
								</Box>
								<Box sx={{ fontSize: 12, color: "#444" }}>
									{item.estacion} — {item.linea}
								</Box>
							</Box>
						))}
					</Box>
				)}

				{/* Consejos */}
				{(consejosTitle || consejosHtml) && (
					<Box data-block-id="text-3">
						{consejosTitle && (
							<Box component="h3" sx={{ ...estiloH3, marginBottom: 1 }}>
								{consejosTitle}
							</Box>
						)}
						{consejosHtml && (
					<Box
						component="ul"
						sx={{
							paddingLeft: 2.5,
							margin: 0,
							lineHeight: 1.6,
							...estiloP,
							fontSize: 13,
							marginBottom: 1.75,
						}}
						dangerouslySetInnerHTML={{ __html: consejosHtml }}
					/>
				)}
					</Box>
				)}

				{/* Mapas y apps */}
				{(mapasTitle || mapasBody) && (
					<Box
						data-block-id="text-4"
						sx={{
							backgroundColor: "#fde1e0",
							border: "3px solid",
							borderColor: actualHeaderColor,
							borderRadius: "12px",
							padding: "10px 14px",
							fontSize: 13,
							color: "#333",
							marginBottom: 1.75,
						}}
					>
						{mapasTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: actualHeaderColor,
									textTransform: "uppercase",
								}}
							>
								{mapasTitle}
							</Box>
						)}
						{mapasBody && (
							<Box
								component="p"
								sx={{ ...estiloP, margin: 0, lineHeight: 1.6 }}
							>
								{mapasBody}
							</Box>
						)}
					</Box>
				)}

				{/* Dónde dormir */}
				{dondeDormir && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 12,
							color: "#444",
							boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
						}}
						dangerouslySetInnerHTML={{ __html: dondeDormir }}
					/>
				)}
			</Box>
		</Box>
	);
};

Template275.thumbnail = "/images/template-1.png";
export default Template275;
